export default __webpack_public_path__ + "static/media/face_compare.64afeeae.png";